module.exports = __webpack_public_path__ + "img/tips-insurance.d9083099.svg";